export const LOCAL_STORAGE_KEY_CONTEXT = 'context';
export const LOCAL_STORAGE_KEY_REDIRECT = 'redirectUri';
export const LOCAL_STORAGE_KEY_VERSIONS = 'versions';
export const LOCAL_STORAGE_KEY_START_DATE = 'startDate';
export const LOCAL_STORAGE_KEY_STATE = 'state';
export const LOCAL_STORAGE_KEY_CODE_VERIFIER = 'code_verifier';
export const SESSION_STORAGE_JDE_LIST = 'jdeList';
export const LOCAL_STORAGE_KEY_WIDGET = 'widget';
export const LOCAL_STORAGE_KEY_APICONTEXT = 'apicontext';
